export default __webpack_public_path__ + "static/media/Messaging-pana.dc465acb.svg";